<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container">
          <div class="lds-ring" v-if="!isLoad">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <section class="np-detail" v-if="isLoad">
            <div class="page-title">
              <h2>Climbing Routes</h2>
            </div>
            <div class="section-title">
              <h3>{{ isEdit ? 'Edit Route' : 'Add Route' }}</h3>
              <a
                @click="$router.back()"
                href="javascript:void(0)"
                class="btn btn--back">
                <div class="btn--back__icon">
                  <svg width="1em" height="1em" class="icon icon-collapse">
                    <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
                  </svg>
                </div>
                <span>Back</span></a
              >
            </div>
            <form action="javascript:void(0)" class="np-detail-form">
              <div class="selects-group">
                <div class="selects-group__item">
                  <div class="np-detail-collapse__body__side">
                    <div class="form-control-group">
                      <span class="form-control-label">Mount</span>
                      <div
                        :class="[
                          'select-wrapper select-wrapper',
                          {'is-active': mountSelect},
                        ]"
                        @click="changeSelects('mountSelect')">
                        <div class="select-trigger">
                          <span class="select-trigger__name">{{
                            mountains.find((item) => item.active)
                              ? mountains.find((item) => item.active).title
                              : ''
                          }}</span>
                          <span class="select-trigger__icon">
                            <svg
                              width="1em"
                              height="1em"
                              class="icon icon-chevron">
                              <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                          ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <div
                              v-for="item in mountains"
                              :key="item.id"
                              :class="[
                                'select-option',
                                {'is-selected': item.active},
                              ]"
                              @click="
                                mountains = mountains.map((mount) => ({
                                  ...mount,
                                  active: mount.id === item.id,
                                }))
                              ">
                              <span class="select-option__name">{{
                                item.title
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="selects-group__item">
                  <div class="np-detail-collapse__body__side">
                    <div class="form-control-group">
                      <span class="form-control-label">Duration</span>
                      <div
                        :class="[
                          'select-wrapper',
                          {'is-active': durationSelect},
                        ]"
                        @click="changeSelects('durationSelect')">
                        <div class="select-trigger">
                          <span class="select-trigger__name"
                            >{{ durationDays }} days</span
                          ><span class="select-trigger__icon">
                            <svg
                              width="1em"
                              height="1em"
                              class="icon icon-chevron">
                              <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                          ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <div
                              v-for="item in durationList"
                              :key="item"
                              :class="[
                                'select-option',
                                {'is-selected': item === durationDays},
                              ]"
                              @click="durationDays = item">
                              <span class="select-option__name"
                                >{{ item }} days</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="np-detail-section">
                <div class="np-detail-collapse__body__side">
                  <div class="form-control-group"><span class="form-control-label">Name for Calculator</span>
                    <div class="form-control-wrap">
                      <input type="text" placeholder="Route's name" @input="isEditFlag = true" v-model="nameForCalculator" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="np-detail-section">
                <div class="np-detail-section__title"><span>1. Info</span></div>
                <div
                  v-for="item in info"
                  :key="item.title"
                  :class="[
                    'np-detail-collapse',
                    'js-collapse',
                    {'is-collapsed': item.collapse},
                  ]">
                  <div class="np-detail-collapse__title">
                    <div class="np-detail-collapse__lang">
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                            :xlink:href="
                              '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                              item.icon
                            "></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text">{{
                        item.title
                      }}</span>
                    </div>
                    <button
                      type="button"
                      data-opened="Hide"
                      data-closed="Show"
                      :class="[
                        'btn',
                        'btn--collapse',
                        'js-collapse-trigger',
                        {'is-active': item.collapse},
                      ]"
                      @click="item.collapse = !item.collapse">
                      <div class="btn--collapse__icon">
                        <svg
                          width="1em"
                          height="1em"
                          class="icon icon-collapse">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
                        </svg>
                      </div>
                    </button>
                  </div>
                  <div class="np-detail-collapse__inner js-collapse-inner">
                    <div class="np-detail-collapse__body">
                      <div class="np-detail-collapse__body__group">
                        <div class="np-detail-collapse__body__side">
                          <div class="form-control-group">
                            <span class="form-control-label">Name</span>
                            <div class="form-control-wrap">
                              <input
                                type="text"
                                placeholder="Route name"
                                @input="isEditFlag = true"
                                v-model="item.name"
                                @focus="
                                  $event.target.parentElement.classList.remove(
                                    'is-error'
                                  )
                                "
                                class="form-control form-control-name" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="np-detail-collapse__body__group">
                        <div class="np-detail-collapse__body__side">
                          <div class="form-control-group">
                            <span class="form-control-label">Description</span>
                            <div class="form-control-wrap">
                              <div class="js-ckeditor">
                                <editor
                                  :editor="editor"
                                  v-model="item.desc"
                                  @input="isEditFlag = true"
                                  :config="editorConfig"></editor>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="np-detail-collapse__body__side">
                          <div class="form-control-group">
                            <span class="form-control-label"
                              >Additional Notes</span
                            >
                            <div class="form-control-wrap">
                              <div class="js-ckeditor">
                                <editor
                                  :editor="editor"
                                  v-model="item.note"
                                  @input="isEditFlag = true"
                                  :config="editorConfig2"></editor>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="np-detail-section">
                <div class="np-detail-section__title">
                  <span>2. Climbing program</span>
                </div>
                <div
                  v-for="item in program"
                  :key="item.title"
                  :class="[
                    'np-detail-collapse',
                    'js-collapse',
                    {'is-collapsed': item.collapse},
                  ]">
                  <div class="np-detail-collapse__title">
                    <div class="np-detail-collapse__lang">
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                            :xlink:href="
                              '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                              item.icon
                            "></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text">{{
                        item.title
                      }}</span>
                    </div>
                    <button
                      type="button"
                      data-opened="Hide"
                      data-closed="Show"
                      :class="[
                        'btn',
                        'btn--collapse',
                        'js-collapse-trigger',
                        {'is-active': item.collapse},
                      ]"
                      @click="item.collapse = !item.collapse">
                      <div class="btn--collapse__icon">
                        <svg
                          width="1em"
                          height="1em"
                          class="icon icon-collapse">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
                        </svg>
                      </div>
                    </button>
                  </div>
                  <div class="np-detail-collapse__inner js-collapse-inner">
                    <div class="np-detail-collapse__body">
                      <div
                        class="np-detail-collapse__body__day"
                        v-for="(day, index) in item.days"
                        :key="day.id">
                        <div class="np-detail-collapse__body__day__top">
                          <div class="np-detail-collapse__body__day__name">
                            <span>Day {{ index + 1 }}</span>
                          </div>
                          <div class="np-detail-collapse__body__day__filters">
                            <div class="form-select-group">
                              <div class="form-control-group">
                                <div
                                  :class="[
                                    'select-wrapper',
                                    {'is-active': day.selectFrom},
                                  ]"
                                  @click="
                                    day.selectFrom = !day.selectFrom
                                    day.selectTo = false
                                  ">
                                  <div class="select-label">
                                    <span>From</span>
                                  </div>
                                  <div class="select-trigger">
                                    <span class="select-trigger__name"
                                      >{{
                                        camps.find(
                                          (camp) => camp.id === day.from
                                        )
                                          ? camps.find(
                                              (camp) => camp.id === day.from
                                            ).names[item.data]
                                          : ''
                                      }}
                                      {{
                                        camps.find(
                                          (camp) => camp.id === day.from
                                        )
                                          ? camps.find(
                                              (camp) => camp.id === day.from
                                            ).meters
                                          : ''
                                      }}
                                      {{
                                        camps.find(
                                          (camp) => camp.id === day.from
                                        )
                                          ? 'm'
                                          : ''
                                      }}</span
                                    ><span class="select-trigger__icon">
                                      <svg
                                        width="1em"
                                        height="1em"
                                        class="icon icon-chevron">
                                        <use
                                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                                    ></span>
                                  </div>
                                  <div class="select-body">
                                    <div class="select-inner js-scrollbar">
                                      <div
                                        v-for="camp in camps"
                                        :key="camp.id"
                                        :class="[
                                          'select-option',
                                          {'is-selected': camp.id === day.from},
                                        ]"
                                        @click="
                                          program = program.map((prog) => ({
                                            ...prog,
                                            days: prog.days.map((d, di) =>
                                              di === day.id
                                                ? {...d, from: camp.id}
                                                : d
                                            ),
                                          }))
                                          isEditFlag = true
                                        ">
                                        <span class="select-option__name"
                                          >{{ camp.names[item.data] }}
                                          {{ camp.meters }} m</span
                                        >
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="form-select-group__divider">
                                <svg
                                  width="1em"
                                  height="1em"
                                  class="icon icon-arrow">
                                  <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-arrow"></use>
                                </svg>
                              </div>
                              <div class="form-control-group">
                                <div
                                  :class="[
                                    'select-wrapper',
                                    {'is-active': day.selectTo},
                                  ]"
                                  @click="
                                    day.selectTo = !day.selectTo
                                    day.selectFrom = false
                                  ">
                                  <div class="select-label">
                                    <span>To</span>
                                  </div>
                                  <div class="select-trigger">
                                    <span class="select-trigger__name"
                                      >{{
                                        camps.find((camp) => camp.id === day.to)
                                          ? camps.find(
                                              (camp) => camp.id === day.to
                                            ).names[item.data]
                                          : ''
                                      }}
                                      {{
                                        camps.find((camp) => camp.id === day.to)
                                          ? camps.find(
                                              (camp) => camp.id === day.to
                                            ).meters
                                          : ''
                                      }}
                                      {{
                                        camps.find((camp) => camp.id === day.to)
                                          ? 'm'
                                          : ''
                                      }}</span
                                    ><span class="select-trigger__icon">
                                      <svg
                                        width="1em"
                                        height="1em"
                                        class="icon icon-chevron">
                                        <use
                                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                                    ></span>
                                  </div>
                                  <div class="select-body">
                                    <div class="select-inner js-scrollbar">
                                      <div
                                        v-for="camp in camps"
                                        :key="camp.id"
                                        :class="[
                                          'select-option',
                                          {'is-selected': camp.id === day.to},
                                        ]"
                                        @click="
                                          program = program.map((prog) => ({
                                            ...prog,
                                            days: prog.days.map((d, di) =>
                                              di === day.id
                                                ? {...d, to: camp.id}
                                                : d
                                            ),
                                          }))
                                          isEditFlag = true
                                        ">
                                        <span class="select-option__name"
                                          >{{ camp.names[item.data] }}
                                          {{ camp.meters }} m</span
                                        >
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <label
                                class="form-control-checkbox form-control-checkbox_summit"
                                @click.prevent="day.summit = !day.summit">
                                <input
                                  type="checkbox"
                                  @click.prevent
                                  :checked="day.summit" /><span
                                  class="form-control-checkbox__box">
                                  <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-check">
                                    <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                                ><span class="form-control-checkbox__name"
                                  >Summit Day</span
                                >
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="np-detail-collapse__body__day__content">
                          <div class="form-control-group">
                            <span class="form-control-label">Description</span>
                            <div class="form-control-wrap">
                              <div class="js-ckeditor">
                                <editor
                                  :editor="editor"
                                  @input="isEditFlag = true"
                                  v-model="day.desc"
                                  :config="editorConfig"></editor>
                              </div>
                            </div>
                          </div>
                          <div class="form-control-group">
                            <span class="form-control-label"
                              >Additional Notes</span
                            >
                            <div class="form-control-wrap">
                              <div class="js-ckeditor">
                                <editor
                                  :editor="editor"
                                  @input="isEditFlag = true"
                                  v-model="day.note"
                                  :config="editorConfig2"></editor>
                              </div>
                            </div>
                          </div>

                          <div
                            class="form-control-photo-group form-control-photo-group--squared">
                            <input
                              type="file"
                              :id="'photo_load' + day.id"
                              class="input-hidden" />
                            <label
                              class="form-control-photo"
                              v-if="!day.photo"
                              @click="
                                idPhoto = +day.id.toString()
                                $emit('changeImage', 'itinerary')
                              "
                              ><span class="form-control-photo__box"></span
                            ></label>
                            <div class="form-control-photo" v-if="day.photo">
                              <span class="form-control-photo__box h-object-fit"
                                ><img
                                  :src="`${API}/documents/share/images/${day.photo}?size=LARGE`"
                                  alt="photo"
                              /></span>
                              <button
                                type="button"
                                class="btn btn--remove"
                                @click="day.photo = null">
                                <svg
                                  width="1em"
                                  height="1em"
                                  class="icon icon-close">
                                  <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                </svg>
                              </button>
                            </div>
                            <div class="form-control-photo-content">
                              <div class="form-control-photo-content__line">
                                <span class="form-control-photo-name"
                                  >Photo</span
                                >
                              </div>
                              <div class="form-control-photo-content__line">
                                <label
                                  class="btn btn--rounded btn-photo-load"
                                  @click="
                                    idPhoto = +day.id.toString()
                                    $emit('changeImage', 'itinerary')
                                  "
                                  >{{
                                    day.photo ? 'Change photo' : 'Add Photo'
                                  }}</label
                                >
                              </div>
                              <div class="form-control-photo-content__line">
                                <span class="form-control-photo-content__size"
                                  >Minimum image size: <b>664 x 280p</b></span
                                ><span class="form-control-photo-content__size"
                                  >Max <b>5 MB</b></span
                                >
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="np-detail-section">
                <div class="np-detail-section__title">
                  <span>Additional Options</span>
                </div>
                <div class="route-add-options">
                  <span class="route-add-options__option-name">Portable Toilet:</span>
                  <div class="route-add-options__switch-wrapper">
                    <ClassicSwitch v-model="additionalOptions.portableToilet.active"/>
                  </div>
                  <span class="route-add-options__option-name">Price ($):</span>
                  <BasicInput type="number"
                              :style="{width: '90px'}"
                              :class="[{'route-add-options--error': additionalOptions.portableToilet.isError}]"
                              v-model="additionalOptions.portableToilet.price" :disabled="!additionalOptions.portableToilet.active"/>
                </div>
              </div>
              <div
                class="np-detail-form__submit np-detail-form__submit--no-border">
                <button
                  type="button"
                  class="btn btn--silver"
                  @click="deleteRouteHandler()"
                  v-if="isEdit">
                  <span>Delete</span>
                </button>
                <button
                  type="button"
                  class="btn btn--green btn--shadowed"
                  @click="isEdit ? updateRouteHandler() : createRouteHandler()">
                  <span>{{ isEdit ? 'Save' : 'Add' }}</span>
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import {
  uploadUserImage,
  API,
  createRoute,
  updateRoute,
  getRoute,
  deleteRoute,
  getCamps,
  getMountains,
} from '@/utilites/api'

import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@/utilites/ckeditor'
import ClassicSwitch from "@/components/UI/Switch/ClassicSwitch.vue";
import BasicInput from "@/components/UI/Inputs/BasicInput.vue";

export default {
  components: {BasicInput, ClassicSwitch, editor: CKEditor.component},
  props: ['user', 'uploadedFile'],
  data() {
    return {
      API: API,
      editor: ClassicEditor,
      editorConfig: {
        placeholder: 'Write description',
      },
      editorConfig2: {
        placeholder: 'Write notes',
      },
      camps: [],
      durationDays: 0,
      nameForCalculator: '',
      durationSelect: false,
      from: false,
      to: false,
      additionalOptions: {
        portableToilet: {
          active: false,
          id: null,
          price: null,
          isError: false,
        },
      },
      mountains: [],
      mountSelect: false,
      idPhoto: null,
      info: [
        {
          title: 'English',
          icon: 'gb',
          collapse: true,
          name: '',
          desc: '',
          note: '',
        },
        {
          title: 'Russian',
          icon: 'rus',
          collapse: false,
          name: '',
          desc: '',
          note: '',
        },
      ],
      program: [
        {
          title: 'English',
          icon: 'gb',
          data: 'EN',
          collapse: true,
          days: [],
        },
        {
          title: 'Russian',
          icon: 'rus',
          data: 'RU',
          collapse: false,
          days: [],
        },
      ],
      isEdit: false,
      route: null,
      save: 0,
      durationList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      isLoad: false,
      isEditFlag: false,
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEditFlag) {
      this.$emit('notLeaveHandler')
    }
    next()
  },
  methods: {
    changeSelects(target) {
      this[target] = !this[target]
    },
    checkErrors() {
      let error = false
      this.additionalOptions.portableToilet.isError = false;
      document.querySelectorAll('.form-control-name').forEach((elem) => {
        if (elem.value.trim().length <= 0) {
          elem.parentElement.classList.add('is-error')
          error = true
        }
      })
      if (this.additionalOptions.portableToilet.active && !this.additionalOptions.portableToilet.price) {
        error = true
        this.additionalOptions.portableToilet.isError = true;
      }
      return error
    },
    uploadPhoto(file, id) {
      uploadUserImage(this.user.access_token, file.target.files[0]).then(
        (res) => {
          this.program = this.program.map((item) => {
            return {
              ...item,
              days: item.days.map((day, index) =>
                +id === index ? {...day, photo: res.id} : day
              ),
            }
          })
        }
      )
    },
    createRouteHandler() {
      if (!this.checkErrors()) {
        createRoute(this.user.access_token, {
          mountId: this.mountains.find((item) => item.active).id,
          portableToilet: {
            id: null,
            price: this.additionalOptions.portableToilet.price,
            active: this.additionalOptions.portableToilet.active
          },
          durationDays: this.durationDays,
          nameForCalculator: this.nameForCalculator,
          info: {
            EN: {
              name: this.info[0].name,
              description: this.info[0].desc,
              additionalNotes: this.info[0].note,
            },
            RU: {
              name: this.info[1].name,
              description: this.info[1].desc,
              additionalNotes: this.info[1].note,
            },
          },
          climbingProgram: this.program[0].days.map((day, index) => {
            return {
              day: index + 1,
              from: day.from,
              to: day.to,
              photo: day.photo,
              summitDay: day.summit,
              programInfo: {
                EN: {
                  description: this.program[0].days[index].desc,
                  additionalNotes: this.program[0].days[index].note,
                },
                RU: {
                  description: this.program[1].days[index].desc,
                  additionalNotes: this.program[1].days[index].note,
                },
              },
            }
          }),
        }).then(() => {
          this.$emit('confirmed')
          this.isEditFlag = false
          this.$router.back()
        })
      } else {
        window.scrollTo({
          top: 0,
        })
      }
    },
    updateRouteHandler() {
      if (!this.checkErrors()) {
        updateRoute(this.user.access_token, {
          id: this.route.id,
          mountId: this.mountains.find((item) => item.active).id,
          portableToilet: {
            id: this.additionalOptions.portableToilet.id,
            price: this.additionalOptions.portableToilet.price,
            active: this.additionalOptions.portableToilet.active
          },
          durationDays: this.durationDays,
          nameForCalculator: this.nameForCalculator,
          info: {
            EN: {
              name: this.info[0].name,
              description: this.info[0].desc,
              additionalNotes: this.info[0].note,
            },
            RU: {
              name: this.info[1].name,
              description: this.info[1].desc,
              additionalNotes: this.info[1].note,
            },
          },
          climbingProgram: this.program[0].days.map((day, index) => {
            return {
              day: index + 1,
              from: day.from,
              to: day.to,
              photo: day.photo,
              summitDay: day.summit,
              programInfo: {
                EN: {
                  description: this.program[0].days[index].desc,
                  additionalNotes: this.program[0].days[index].note,
                },
                RU: {
                  description: this.program[1].days[index].desc,
                  additionalNotes: this.program[1].days[index].note,
                },
              },
            }
          }),
        }).then(() => {
          this.$emit('confirmed')
          this.isEditFlag = false
          this.$router.back()
        })
      } else {
        window.scrollTo({
          top: 0,
        })
      }
    },
    deleteRouteHandler() {
      deleteRoute(this.user.access_token, this.route.id).then((res) => {
        this.$router.back()
        this.$emit('confirmed')
      })
    },
    getLangByIndex(index) {
      switch (index) {
        case 1:
          return 'RU'
        default:
          return 'EN'
      }
    }
  },
  beforeCreate() {
    document.title = 'Climbing / Kilimajaro Routes / Detail'
  },
  mounted() {
    document.title = 'Climbing / Kilimajaro Routes / Detail'
    this.isEdit = this.$route.params.id
    // this.durationDays = 5
    if (this.isEdit) {
      getRoute(this.user.access_token, this.isEdit).then((res) => {
        this.route = res
        getMountains(this.user.access_token).then((result) => {
          this.mountains = result.map((item) => ({
            ...item,
            active: item.id === res.mountId,
          }))
          this.isLoad = true
        })
        this.durationDays = res.durationDays
        this.nameForCalculator = res.nameForCalculator
        if (res.portableToilet) {
          this.additionalOptions.portableToilet = res.portableToilet;
        }
        this.info = [
          {
            title: 'English',
            icon: 'gb',
            collapse: true,
            name: res.info.EN.name,
            desc: res.info.EN.description,
            note: res.info.EN.additionalNotes,
          },
          {
            title: 'Russian',
            icon: 'rus',
            collapse: false,
            name: res.info.RU.name,
            desc: res.info.RU.description,
            note: res.info.RU.additionalNotes,
          },
        ]
        this.program = this.program.map((item, index) => {
          return {
            ...item,
            days: res.climbingProgram.map((day, i) => {
              const lang = this.getLangByIndex(index)
              return {
                id: day.day - 1,
                selectFrom: false,
                selectTo: false,
                from: day.from,
                to: day.to,
                desc: res.climbingProgram[i].programInfo[lang].description,
                note: res.climbingProgram[i].programInfo[lang].additionalNotes,
                photo: day.photo,
                summit: day.summitDay,
              }
            }),
          }
        })
      })
    } else {
      getMountains(this.user.access_token).then((result) => {
        this.mountains = result
      })
      this.isLoad = true
      this.durationDays = 5
    }
  },
  watch: {
    mountains(value) {
      if (value.length > 0 && this.isEdit) {
        const activeMountain = this.mountains.find((item) => item.active)
        getCamps(this.user.access_token, activeMountain.id).then((res) => {
          this.camps = res
        })
      }
    },
    durationDays() {
      this.program = this.program.map((item) => {
        if (+this.durationDays > item.days.length) {
          return {
            ...item,
            days: item.days
              .concat(
                Array(this.durationDays - item.days.length).fill({
                  selectFrom: false,
                  selectTo: false,
                  from: '',
                  to: '',
                  desc: '',
                  note: '',
                  photo: null,
                  summit: false,
                })
              )
              .map((day, index) => ({...day, id: index})),
          }
        } else if (+this.durationDays < item.days.length) {
          return {
            ...item,
            days: item.days.slice(0, +this.durationDays),
          }
        }
        return item
      })
      window.addEventListener('click', (event) => {
        if (!event.target.closest('.select-wrapper')) {
          this.program = this.program.map((item) => {
            if (item) {
              return {
                ...item,
                days: item.days.map((day) => ({
                  ...day,
                  selectFrom: false,
                  selectTo: false,
                })),
              }
            }
          })
          this.durationSelect = false
          this.mountSelect = false
        }
      })
    },
    uploadedFile() {
      if (this.uploadedFile) {
        this.program = this.program.map((item) => {
          return {
            ...item,
            days: item.days.map((day, index) =>
              +this.idPhoto === index ? {...day, photo: this.uploadedFile} : day
            ),
          }
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.route-add-options {
  display: flex;
  align-items: center;

  &__option-name {
    margin-right: 13px;
    color: #2E2E2E;
    font-size: 12px;
    font-weight: 500;
  }

  &--error {
    border: 2px solid #F49898;
    border-radius: 5px;
  }

  &__switch-wrapper {
    margin-right: 33px;
  }
}
</style>
